// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recorder-status[data-v-d6017700]{display:flex;flex:1;flex-direction:column}.status-text[data-v-d6017700]{align-self:center;display:flex;text-align:center}.volume-meter[data-v-d6017700]{display:flex}.volume-meter meter[data-v-d6017700]{display:flex;flex:1;height:.75rem}.audio-progress-bar[data-v-d6017700],.processing-bar[data-v-d6017700]{height:.75rem}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
